import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import ClassroomRoutes from './components/classroom/ClassroomRoutes';
import TemplateManagerRoutes from './components/templates/TemplateManagerRoutes';
import WhiteboardRoutes from './components/whiteboard/Routes';
import AllBreakoutRooms from './pages/AllBreakoutRooms';
import Attendance from './pages/Attendance';
import Dashboard from './pages/Dashboard';
import DownloadPage from './pages/DownloadPage';
import Error404 from './pages/Error404';
import ErrorBrowser from './pages/ErrorBrowser';
import FileViewer from './pages/FileViewer';
import LegacyRecordingsPage from './pages/LegacyRecordings';
import LmsAuthError from './pages/LmsAuthError';
import LmsAuthSuccess from './pages/LmsAuthSuccess';
import LTIError from './pages/LTIError';
import MicrosoftAuthRedirect from './pages/MicrosoftAuthRedirect';
import MicrosoftAuthSuccess from './pages/MicrosoftAuthSuccess';
import Roster from './pages/Roster';
import VideoPlayback from './pages/VideoPlayback';
import ZoomAuthRedirect from './pages/ZoomAuthRedirect';
import ZoomAuthSuccess from './pages/ZoomAuthSuccess';
import AdminSettingsPage from './views/AdminSettings';
import BreakoutRoomOptions from './views/BreakoutRoomOptions';
import ClassModal from './views/ClassModal';
import InviteStudents from './views/InviteStudents';
import Login from './views/Login';
import AuthHandler from './views/Login/AuthHandler';
import MSCalendarIntegration from './views/MsCalendarIntegration';
import PasswordReset from './views/PasswordReset';
import PortalPage from './views/Portal';
import ReportProblemModal from './views/ReportProblem';
import SignUp from './views/SignUp';
import ValidateEmail from './views/ValidateEmail';

const Routes = () => (
    <Router basename={'/react'}>
        <Switch>
            <Route exact path="/" component={DownloadPage} />
            <Route path="/adminSettings" component={AdminSettingsPage} />
            <Route path="/admin-settings" component={AdminSettingsPage} />
            <Route path="/portal" component={PortalPage} />
            <Route path="/start" component={DownloadPage} />
            <Route path="/download" component={DownloadPage} />
            <Route path="/legacy-recordings" component={LegacyRecordingsPage} />
            <Route path="/lti" component={ClassroomRoutes} />
            <Route path="/template-manager" component={TemplateManagerRoutes} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/sign-up" component={SignUp} />
            <Route exact path="/auth" component={AuthHandler} />
            <Route exact path="/password-reset" component={PasswordReset} />
            <Route exact path="/validate-email" component={ValidateEmail} />
            <Route exact path="/attendance/class/:classId" component={Attendance} />
            <Route exact path="/roster/:classUuid" component={Roster} />
            <Route exact path="/inviteStudents" component={InviteStudents} />
            <Route exact path="/invite-students" component={InviteStudents} />
            <Route exact path="/breakout-room-options" component={BreakoutRoomOptions} />
            <Route exact path="/class/create" component={ClassModal} />
            <Route exact path="/class/:classUuid/edit" component={ClassModal} />
            <Route exact path="/file-viewer" component={FileViewer} />
            <Route path="/dashboard/:classUuid" component={Dashboard} />
            <Route path="/whiteboard" component={WhiteboardRoutes} />
            <Route path="/lms-launch-error" component={LTIError} />
            <Route path="/lms-auth-success" component={LmsAuthSuccess} />
            <Route path="/lms-auth-error" component={LmsAuthError} />
            <Route path="/microsoft-auth-launch" component={MicrosoftAuthRedirect} />
            <Route path="/microsoft-auth-success" component={MicrosoftAuthSuccess} />
            <Route path="/zoom-auth-launch" component={ZoomAuthRedirect} />
            <Route path="/zoom-auth-success" component={ZoomAuthSuccess} />
            <Route path="/all-breakout-rooms" component={AllBreakoutRooms} />
            <Route path="/browser-error" component={ErrorBrowser} />
            <Route path="/msCalendarIntegration" component={MSCalendarIntegration} />
            <Route path="/report-problem" component={ReportProblemModal} />
            <Route path="/videos/playback/:meetingId/:tabId" component={VideoPlayback} />
            <Route component={Error404} />
        </Switch>
    </Router>
);

export default Routes;
